import { jsx, Global } from '@emotion/react';
import 'react';
import { resetStyles, brandStyles } from './style.js';

var ResetStyles = () => jsx(Global, {
  styles: resetStyles
});
var BrandStyles = () => jsx(Global, {
  styles: brandStyles
});

export { BrandStyles, ResetStyles };
